import environment from './base'

const env = environment()
export default env
